//ShareLink Claim Codes Manager

let ShareLinksActions = Reflux.createActions([
    'fetchShareLinks', 'createShareLink', 'updateShareLink', 'deleteShareLink'
]);

class ShareLinksStore extends Reflux.Store {
    constructor() {
        super();
        this.state = {
            shares: []
        };
        this.listenables = ShareLinksActions;
    }

    onFetchShareLinks() {
        let _self = this;
        httpGet(buildRoute(mantlroutes.portfolio_shares, {})).then(
            function(value) {
                var response = JSON.parse(value);
                _self.setState({ shares: response });
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Retrieve Share Links')
            });
    }

    onCreateShareLink(data) {
        httpPost(buildRoute(mantlroutes.portfolio_shares, {}) + formatParams({ 'force': true }), data).then(
            function(value){
                ShareLinksActions.fetchShareLinks();
                alertify.success("Link Created");
            })
        .catch(
            function(reason) {
                alertify.error("Unable to create share.");
            });
    }

    onUpdateShareLink(sharecode,data) {
        httpPatch(buildRoute(mantlroutes.portfolio_share_item,{ sharecode: sharecode }), data).then(
            function(value){
                ShareLinksActions.fetchShareLinks();
                alertify.success("Updated");
            })
        .catch(
            function(reason) {
                alertify.error("Unable to update share.");
            });
    }

    onDeleteShareLink(sharecode) {
        httpDelete(buildRoute(mantlroutes.portfolio_share_item,{ sharecode: sharecode })).then(
            function(value){
                ShareLinksActions.fetchShareLinks();
                alertify.log("Deleted");
            })
        .catch(
            function(reason) {
                alertify.error("Unable to delete share.");
            });
    }
}

class ShareLinks {
    constructor(options) {
        this.defaults = {
            target: null,
            path: null
        }
        this.settings = extend( {}, this.defaults, options );
        this.Actions = ShareLinksActions;
        this.render();
        this.initStore();
    }

    render() {
        let target = this.settings.target;
        if(this.settings.target == null) {
            console.error('Render ShareLinks called with a null target id');
            return false;
        }
        ReactDOM.render(<ShareLinksWrapper settings={this.settings} />, document.getElementById(target));
    }

    initStore() {
        this.Actions.fetchShareLinks();
    }

}

//Reflux.Component extends React.Component
class ShareLinksWrapper extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = new ShareLinksStore(); // <- just assign the store class itself
    }

    render() {
        return (
            <section className="sharelinks">
                <ShareLinksList shares={this.state.shares} settings={this.props.settings} />
                <ShareLinksAdd settings={this.props.settings} />
            </section>
        );
    }
}

class ShareLinksList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const targetPath = this.props.settings.path;
        let filtered = [];
        this.props.shares.forEach(function(element) {
            if(element.path == targetPath) {
                filtered.push(element);
            }
        });

        const shares = filtered.map((share) =>
            <ShareLinksListItem share={share} key={share.id} />
        );

        return (
            <ul className="collection collection--receipt">
                {shares}
            </ul>
        );
    }
}

class ShareLinksListItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleSocialTwitter = this.handleSocialTwitter.bind(this);
        this.handleSocialFacebook = this.handleSocialFacebook.bind(this);
        this.handleSocialLinkedIn = this.handleSocialLinkedIn.bind(this);
        this.encodedURL = encodeURI(this.props.share.url);
        this.introText = encodeURI("Check out my skills evidence");
        this.hashtags = "OpenBadges"; //string of comma-delimited values
        this.viaCredit = "Anthology Inc";
    }

    handleDelete() {
        ShareLinksActions.deleteShareLink(this.props.share.code);
    }

    handleSocialPopup(popupURL) {
        // Set values for window
        let intWidth = '500';
        let intHeight = '500';
        let strResize = 'yes';

        // Set title and open popup with focus on it
        let strTitle = 'Share My Skills Evidence';
        let strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize;
        let objWindow = window.open(popupURL, strTitle, strParam).focus();
    }

    handleSocialTwitter() {
        let tweetURL = 'https://twitter.com/intent/tweet' + formatParams({
            url: this.encodedURL,
            text: this.introText,
            hashtags: this.hashtags
        });
        this.handleSocialPopup(tweetURL);
    }

    handleSocialFacebook() {
        let facebookURL = 'https://www.facebook.com/sharer.php' + formatParams({
            "u": this.encodedURL
        });
        this.handleSocialPopup(facebookURL);
    }

    handleSocialLinkedIn() {
        let linkedinURL = 'https://www.linkedin.com/shareArticle' + formatParams({
            url: this.encodedURL,
            mini: 'true',
            summary: this.introText
        });
        this.handleSocialPopup(linkedinURL);
    }

    render() {
        return (
            <li className="collection-item" data-path={this.props.share.path}>
                <div className="input-group input-group--full">
                    <label htmlFor={"sharelink_"+this.props.share.id} className="input-prefix" title="Share Link"><Icon classes="icon-cloud" /></label>
                    <input type="text" id={"sharelink_"+this.props.share.id} readOnly={true} className="input--long" defaultValue={this.props.share.url} />
                    <button type="button" onClick={this.handleSocialTwitter} className="input-suffix input-suffix--stacked button button--skinny"><Icon classes="icon-twitter icon--color-twitter" title="Share on Twitter" /></button>
                    <button type="button" onClick={this.handleSocialFacebook} className="input-suffix input-suffix--stacked button button--skinny"><Icon classes="icon-facebook icon--color-facebook" title="Share on Facebook" /></button>
                    <button type="button" onClick={this.handleSocialLinkedIn} className="input-suffix input-suffix--stacked button button--skinny"><Icon classes="icon-linkedin icon--color-linkedin" title="Share on Facebook" /></button>
                    <button type="button" onClick={this.handleDelete} className="input-suffix button button--flat button--skinny"><Icon classes="icon-trash" title="Delete Link" /></button>
                </div>
                <p className="text--small"><b>Created</b> <FormattedDate date={this.props.share.created} /> <span className="emspace"></span> <b>Expires</b> {this.props.share.expires && (<FormattedDate date={this.props.share.expires} />)}{!this.props.share.expires && (<span className="text--muted">Never</span>)}</p>

            </li>
        );
    }
}

class ShareLinksAdd extends React.Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.state = {
            path: this.props.settings.path,
            expires: null
        };
    }

    handleInputChange(event) {
        //only used as a fallback if the basic input doesn't init calendar picker
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    componentDidMount() {
        let _self = this;
        let shareLinkExpiresPicker = new Pikaday({
            field: document.getElementById('share_link_expires'),
            defaultDate: new Date(),
            onSelect: function(date) {
                _self.setState({
                    expires: date.toJSON()
                });
            }
        });
    }

    handleSave() {
        ShareLinksActions.createShareLink({ path: this.state.path, expires: this.state.expires });
    }

    render() {
        return (
            <div className="form form--inline text--center">
                <h2 className="h4"><Icon classes="icon-cloud icon--success" /> New Share Link</h2>
                <div className="input-group">
                    <label htmlFor="share_link_expires" className="input-prefix" title="Optionally Expires On"><Icon classes="icon-calendar" /></label>
                    <input type="text" id="share_link_expires" name="expires" placeholder="Optionally expires on..." className="input--long datepicker" defaultValue={null} onChange={this.handleInputChange} />
                </div>
                <button className="button--skinny button--success" onClick={this.handleSave}><i className="icon-plus"></i> Create Share Link</button>
            </div>
        );
    }
}
